import { render } from "./PlantCreate.vue?vue&type=template&id=e085353c"
import script from "./PlantCreate.vue?vue&type=script&lang=js"
export * from "./PlantCreate.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__